// Lightweight image preloader with optional concurrency control
export function preloadImages(urls, { concurrency = 4 } = {}) {
  if (!Array.isArray(urls) || urls.length === 0) return Promise.resolve([]);

  const results = [];
  let active = 0;
  let index = 0;

  return new Promise((resolve) => {
    const next = () => {
      if (index >= urls.length && active === 0) {
        resolve(results);
        return;
      }
      while (active < concurrency && index < urls.length) {
        const url = urls[index++];
        if (!url) continue;
        active++;
        const img = new Image();
        const onDone = (ok) => () => {
          results.push({ url, ok });
          active--;
          next();
        };
        img.onload = onDone(true);
        img.onerror = onDone(false);
        // Use decode() when available for better paint timing, fallback to src assignment
        try {
          img.src = url;
          if (img.decode) {
            img.decode().then(onDone(true)).catch(onDone(false));
          }
        } catch {
          // ignore
        }
      }
    };
    next();
  });
}

export function preloadOnIdle(urls, options) {
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(() => preloadImages(urls, options));
  } else {
    setTimeout(() => preloadImages(urls, options), 0);
  }
}
